/* Product-card metal swatches. Moved out of snippets/card-product.liquid on 22 Sep 2026:
   the snippet printed this whole script inside EVERY card (~9.7 KB x 24 per collection page),
   and each copy bound click handlers to every card, so each swatch carried N duplicate handlers.
   Loaded once from layout/theme.liquid (defer, so DOMContentLoaded still fires after it). */
document.addEventListener('DOMContentLoaded', function() {
  // Enhanced variant selection functionality
  function initializeVariantSelection() {
    const productCards = document.querySelectorAll('[data-product-id]');
    
    productCards.forEach(function(productCard) {
      const productId = productCard.dataset.productId;
      if (!productId) return;

      const variantDataScript = document.querySelector('.variant-data[data-product-id="' + productId + '"]');
      if (!variantDataScript) return;

      const productData = JSON.parse(variantDataScript.textContent).product;
      const variantSwatches = productCard.querySelectorAll('.variant-swatch[data-product-id="' + productId + '"]');
      
      // Initialize default selected variant based on the current variant from Liquid
      initializeDefaultVariant(productCard, productData);
      
      // Add click handlers
      variantSwatches.forEach(function(swatch) {
        swatch.addEventListener('click', function(e) {
          e.preventDefault();
          e.stopPropagation();
          handleVariantSelection(this, productCard, productData);
        });
      });
    });
  }
  
  function initializeDefaultVariant(productCard, productData) {
    const productId = productData.id;
    const selectedVariantId = productData.selected_variant_id;
    
    // Find the selected variant
    const selectedVariant = productData.variants.find(v => v.id === selectedVariantId);
    if (!selectedVariant) return;
    
    // Set active states for swatches that match the selected variant
    const swatches = productCard.querySelectorAll('.variant-swatch[data-product-id="' + productId + '"]');
    swatches.forEach(function(swatch) {
      const optionPosition = parseInt(swatch.dataset.optionPosition);
      const variantValue = swatch.dataset.variantValue;
      
      // Check if this swatch matches the current selected variant
      let matches = false;
      if (optionPosition === 1 && selectedVariant.option1 === variantValue) matches = true;
      if (optionPosition === 2 && selectedVariant.option2 === variantValue) matches = true;
      if (optionPosition === 3 && selectedVariant.option3 === variantValue) matches = true;
      
      if (matches) {
        swatch.classList.add('active');
      } else {
        swatch.classList.remove('active');
      }
    });
    
    // Update the UI with the selected variant
    updateProductUI(productCard, selectedVariant, productData);
  }
  
  function handleVariantSelection(clickedSwatch, productCard, productData) {
    const productId = productData.id;
    const variantValue = clickedSwatch.dataset.variantValue;
    const optionPosition = parseInt(clickedSwatch.dataset.optionPosition);
    
    // Remove active class from all swatches in the same option group
    const siblingSwatches = productCard.querySelectorAll('.variant-swatch[data-product-id="' + productId + '"][data-option-position="' + optionPosition + '"]');
    siblingSwatches.forEach(function(sibling) {
      sibling.classList.remove('active');
    });
    
    // Add active class to clicked swatch
    clickedSwatch.classList.add('active');
    
    // Get currently selected options
    const selectedOptions = getCurrentlySelectedOptions(productCard, productData);
    
    // Find the best matching variant
    const matchingVariant = findBestMatchingVariant(productData.variants, selectedOptions);
    
    if (matchingVariant) {
      // Update variant inputs and UI
      updateProductUI(productCard, matchingVariant, productData);
    }
  }
  
  function getCurrentlySelectedOptions(productCard, productData) {
    const productId = productData.id;
    const selectedOptions = [];
    
    // Initialize with nulls
    for (let i = 0; i < productData.options.length; i++) {
      selectedOptions[i] = null;
    }
    
    // Get active swatches and build selected options
    const activeSwatches = productCard.querySelectorAll('.variant-swatch[data-product-id="' + productId + '"].active');
    activeSwatches.forEach(function(swatch) {
      const pos = parseInt(swatch.dataset.optionPosition) - 1;
      selectedOptions[pos] = swatch.dataset.variantValue;
    });
    
    return selectedOptions;
  }
  
  function findBestMatchingVariant(variants, selectedOptions) {
    let bestMatch = null;
    let bestMatchScore = 0;
    
    for (let variant of variants) {
      let matchScore = 0;
      let isMatch = true;
      
      // Check each option
      if (selectedOptions[0] !== null) {
        if (variant.option1 === selectedOptions[0]) {
          matchScore++;
        } else {
          isMatch = false;
        }
      }
      
      if (selectedOptions[1] !== null) {
        if (variant.option2 === selectedOptions[1]) {
          matchScore++;
        } else {
          isMatch = false;
        }
      }
      
      if (selectedOptions[2] !== null) {
        if (variant.option3 === selectedOptions[2]) {
          matchScore++;
        } else {
          isMatch = false;
        }
      }
      
      // If this variant matches all selected options and has a better score
      if (isMatch && matchScore > bestMatchScore) {
        bestMatch = variant;
        bestMatchScore = matchScore;
      }
    }
    
    return bestMatch;
  }
  
  function updateProductUI(productCard, variant, productData) {
    const productId = productData.id;
    
    // Update all variant input fields for this product
    const variantInputs = productCard.querySelectorAll('.variant-input-' + productId);
    variantInputs.forEach(function(input) {
      input.value = variant.id;
      input.setAttribute('data-current-variant-id', variant.id);
      input.disabled = !variant.available;
    });
    
    // Update all add to cart buttons for this product
    const addToCartBtns = productCard.querySelectorAll('.add-to-cart-btn-' + productId);
    addToCartBtns.forEach(function(btn) {
      const btnText = btn.querySelector('.btn-text-' + productId);
      if (variant.available) {
        btn.disabled = false;
        if (btnText) {
          btnText.textContent = btn.dataset.addToCartText || 'Add to cart';
        }
      } else {
        btn.disabled = true;
        if (btnText) {
          btnText.textContent = btn.dataset.soldOutText || 'Sold out';
        }
      }
    });
    
    // Card photo follows the chosen metal (Brad, 22 Sep 2026):
    //  - the selected variant has its own photo -> show it
    //  - it has none -> keep / restore the card's original photo, so a product without
    //    imagery for both metals shows the same picture for both.
    // The old code set only img.src; the <img> carries a srcset, and srcset always wins,
    // so the photo never visibly changed. Both are swapped now, at the card's own widths.
    const productImage = productCard.querySelector('#product-image-' + productId);
    if (productImage) {
      if (!productImage.dataset.auraOrigSrc) {
        productImage.dataset.auraOrigSrc = productImage.getAttribute('src') || '';
        productImage.dataset.auraOrigSrcset = productImage.getAttribute('srcset') || '';
      }
      let src = productImage.dataset.auraOrigSrc;
      let srcset = productImage.dataset.auraOrigSrcset;
      if (variant.image) {
        const base = variant.image.replace(/([?&])width=\d+&?/, '$1').replace(/[?&]$/, '');
        const join = base.indexOf('?') === -1 ? '?' : '&';
        const widths = [165, 246, 360, 493, 533, 720, 823, 940, 1066, 1206, 1346, 1600, 2048];
        src = base + join + 'width=2048';
        srcset = widths.map(function (w) { return base + join + 'width=' + w + ' ' + w + 'w'; }).join(', ');
      }
      if (productImage.getAttribute('src') !== src) {
        // Preload roughly the candidate the browser will pick for this card, not the 2048 fallback.
        const need = (productImage.clientWidth || 400) * (window.devicePixelRatio || 1);
        const pick = (srcset.split(', ').map(function (c) { return c.split(' '); })
          .find(function (c) { return parseInt(c[1], 10) >= need; }) || [src])[0];
        const apply = function () {
          if (srcset) productImage.setAttribute('srcset', srcset); else productImage.removeAttribute('srcset');
          productImage.setAttribute('src', src);
        };
        const preload = new Image();
        preload.onload = apply;
        preload.onerror = apply;
        preload.src = pick;
      }
    }
    
    // Update price if available (this would need additional implementation based on your price rendering)
    // You might need to make an AJAX call to get updated pricing or implement price updates here
  }
  
  // Handle collection page filtering by reinitializing after page updates
  function handleCollectionPageUpdates() {
    // MutationObserver to watch for DOM changes (when filters are applied)
    const observer = new MutationObserver(function(mutations) {
      let shouldReinitialize = false;
      mutations.forEach(function(mutation) {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          // Check if new product cards were added
          mutation.addedNodes.forEach(function(node) {
            if (node.nodeType === Node.ELEMENT_NODE && 
                (node.classList.contains('product-card-wrapper') || 
                 node.querySelector('.product-card-wrapper'))) {
              shouldReinitialize = true;
            }
          });
        }
      });
      
      if (shouldReinitialize) {
        setTimeout(initializeVariantSelection, 100);
      }
    });
    
    // Observe the main content area where products are loaded
    const mainContent = document.querySelector('#main-collection-product-grid, .collection, main');
    if (mainContent) {
      observer.observe(mainContent, {
        childList: true,
        subtree: true
      });
    }
  }
  
  // Initialize everything
  initializeVariantSelection();
  handleCollectionPageUpdates();
  
  // Also reinitialize on popular collection filter events
  document.addEventListener('collection:loaded', initializeVariantSelection);
  document.addEventListener('facets:loaded', initializeVariantSelection);
});
